import { SxProps } from '@mui/material'

interface FanaticsCashStyles {
  wrapper: SxProps
}

export const fanaticsCashStyles: FanaticsCashStyles = {
  wrapper: {
    mt: { xs: 0.5 },
    width: 64,
    height: 23,
  },
}
